/**
 * Mr. B — a fictional demo profile with seven fictional medications used
 * to teach new users the interface. Everything on this profile is
 * clearly labelled as sample data throughout the UI.
 *
 * Nothing here is real medical advice. The medication combinations, doses,
 * and manufacturers are invented for demonstration and do not represent a
 * clinically valid regimen.
 */
export const DEMO_PROFILE_ID = "demo-mr-b";

const now = new Date().toISOString();

export const MR_B_DEMO = {
  id: DEMO_PROFILE_ID,
  name: "Mr. B (sample)",
  is_demo: true,
  created_at: now,
  updated_at: now,
  meds: [
    {
      id: "demo-med-1",
      generic_name: "Lisinopril",
      brand_name: "Zestril",
      strength: "10 mg",
      directions: "Take one tablet by mouth every morning",
      purpose: "Blood pressure",
      times: ["morning"],
      form: "tablet",
      imprint_front: "LUPIN 10",
      imprint_back: "",
      manufacturer: "Lupin",
      pharmacy: "Community Pharmacy",
      do_not_confuse: "losartan, lansoprazole",
      label_reviewed: true,
    },
    {
      id: "demo-med-2",
      generic_name: "Atorvastatin",
      brand_name: "Lipitor",
      strength: "20 mg",
      directions: "Take one tablet by mouth at bedtime",
      purpose: "Cholesterol",
      times: ["bedtime"],
      form: "tablet",
      imprint_front: "PD 156",
      imprint_back: "20",
      manufacturer: "Pfizer",
      pharmacy: "Community Pharmacy",
      do_not_confuse: "atenolol",
      label_reviewed: true,
    },
    {
      id: "demo-med-3",
      generic_name: "Metformin",
      brand_name: "Glucophage",
      strength: "500 mg",
      directions: "Take one tablet by mouth twice daily with food",
      purpose: "Blood sugar",
      times: ["morning", "evening"],
      form: "tablet",
      imprint_front: "IP 178",
      imprint_back: "500",
      manufacturer: "Amneal",
      pharmacy: "Community Pharmacy",
      do_not_confuse: "metoprolol",
      label_reviewed: true,
    },
    {
      id: "demo-med-4",
      generic_name: "Levothyroxine",
      brand_name: "Synthroid",
      strength: "50 mcg",
      directions: "Take one tablet on empty stomach, 30 minutes before breakfast",
      purpose: "Thyroid",
      times: ["morning"],
      form: "tablet",
      imprint_front: "SYNTHROID 50",
      imprint_back: "",
      manufacturer: "AbbVie",
      pharmacy: "Community Pharmacy",
      do_not_confuse: "liothyronine",
      label_reviewed: true,
    },
    {
      id: "demo-med-5",
      generic_name: "Aspirin (low-dose)",
      brand_name: "Bayer 81mg",
      strength: "81 mg",
      directions: "Take one tablet by mouth every morning with food",
      purpose: "Prevent blood clots",
      times: ["morning"],
      form: "tablet (enteric coated)",
      imprint_front: "BAYER",
      imprint_back: "",
      manufacturer: "Bayer",
      pharmacy: "Community Pharmacy",
      do_not_confuse: "acetaminophen, ibuprofen",
      label_reviewed: true,
    },
    {
      id: "demo-med-6",
      generic_name: "Vitamin D3",
      brand_name: "Nature Made",
      strength: "1000 IU",
      directions: "Take one softgel by mouth every morning",
      purpose: "Bone health",
      times: ["morning"],
      form: "softgel",
      imprint_front: "",
      imprint_back: "",
      manufacturer: "Nature Made",
      pharmacy: "OTC (store brand)",
      do_not_confuse: "prescription vitamin D 50,000 IU (weekly)",
      label_reviewed: true,
    },
    {
      id: "demo-med-7",
      generic_name: "Trazodone",
      brand_name: "Desyrel",
      strength: "50 mg",
      directions: "Take one tablet by mouth at bedtime as needed for sleep",
      purpose: "Sleep",
      times: ["bedtime"],
      form: "tablet",
      imprint_front: "PLIVA 433",
      imprint_back: "",
      manufacturer: "Teva",
      pharmacy: "Community Pharmacy",
      do_not_confuse: "tramadol",
      label_reviewed: true,
    },
  ],
};
